import { defineStore } from 'pinia';
import { actions, state, getters } from '@/stores/methods';


export const useCustomerStore = defineStore('customer', {
  state: state,
  actions: actions,
  getters: {
    getCountByPhoneNumber: (state) => {
      return (phone) => {
        return state.collection.filter(c => {
          return c.attributes['phone-number'] === phone;
        }).length;
      };
    },
    ...getters,
  }
});
